import { buildCommerceEngine, buildContext, getOrganizationEndpoint } from '@coveo/headless/commerce';
import { useCheckAuthorityType } from '../../hooks/useCheckUser';
import { AUTHORITY_TYPE } from '../global/constants';
import { STORAGE_CONFIG } from '../../constants/storageConfig';
import { getProductListUrl } from './utils/searchUtils';

const coveoConfig =
    document.querySelector('meta[name="generic-variables"]')?.dataset ||
    document.querySelector('div[name="generic-variables"]')?.dataset;

const handlePreprocessRequest = (request = null, clientOrigin = null) => {
    const body = JSON.parse(request.body);
    if (body.facets) {
        body.facets.requests = body?.facets?.map(req => {
            //since numerical facets doesnt support reordering
            if (req.values?.length > 0 && req?.type !== 'numericalRange') {
                if (Array(req.values).findIndex(item => item.state === 'selected') > -1) {
                    //atleast one item is selected
                    req.freezeCurrentValues = true;
                }
            } else {
                req.freezeCurrentValues = false;
            }
            return req;
        });
    }
    body.trackingId=localStorage.getItem(STORAGE_CONFIG.LOCAL_STORAGE.COMPANYID) == 2 ? 'en_CA' : 'en_US';
    body.country =localStorage.getItem(STORAGE_CONFIG.LOCAL_STORAGE.COMPANYID) == 2 ?"ca":"US";  
    const contextData = JSON.parse(sessionStorage.getItem('plpContextData') || '{}');
    body.context = { ...body.context, ...contextData };
    request.body = JSON.stringify(body);
    return request;
};

const additionalFields= [
    'categoryl2',
    'categoryl3',
    'productcatsortindex',
    'ec_primary_image',
    'ec_skus',
    'ec_product_url',
    'ec_show_onlinecatalog',
    'ec_disable_addtocartoption',
    'source',
    'ec_category',
    'ec_category_id',
    'ec_pc_inventory',
    'ec_meta_title',
    'ec_meta_description',
    'ec_specialtytypes',
    'ec_specialtytypecode',
    'ec_analysisgroupcode',
    'ec_specifications',
    'ec_isgreenleaf',
    'ec_greenleafdata'
];

const getProductListingUrl = () => {
    let url = 'https://www.sunbeltrentals.com';
    if (window.location.pathname.includes('equipment-rental/')) {
        url += getProductListUrl();
    } else {
        url =
            'https://www.sunbeltrentals.com/equipment-rental/aerial-work-platforms-scaffolding-and-ladders/electric-scissorlifts/';
    }
    sessionStorage.setItem("listingReqUrl", url)
    return url;
};

export const plp_defaultPlpEngineOptions = {
    configuration: {
        organizationId: coveoConfig?.orgid || 'sunbeltrentalsnonproduction2l4v2y05t',
        accessToken:  coveoConfig?.plpaccesstoken || 'xxc5d4b939-0b2d-4c78-bd1b-8c10a3da9c4b', //nonPro2 key
        // accessToken: coveoConfig?.accesstoken || 'xxc5d4b939-0b2d-4c78-bd1b-8c10a3da9c4b', // key to run in local setup
        organizationEndpoints: getOrganizationEndpoint(coveoConfig?.orgid || 'sunbeltrentalsnonproduction2l4v2y05t'),
        search: {
            searchHub: coveoConfig?.coveoSearchhub || 'Sunbelt-Commerce'
        },
        analytics: {
            trackingId: localStorage.getItem(STORAGE_CONFIG.LOCAL_STORAGE.COMPANYID) == 2 ? 'en_CA' : 'en_US',
            analyticsClientMiddleware: (eventType, payload) => {
                payload.originLevel1 = 'Listing';
                payload.originLevel2 = sessionStorage.getItem('listingReqUrl') || '';
                return payload;
            }
        },
        preprocessRequest: handlePreprocessRequest,
        context: localStorage.getItem(STORAGE_CONFIG.LOCAL_STORAGE.COMPANYID) == 2 ?{
            currency: 'USD',
            locale: 'en-CA',
            language: 'en',
            country: 'ca',
            view: {
                // url: "https://www.sunbeltrentals.com/equipment-rental/air-compressors-and-air-tools/air-compressors/", // uncomment for local
                url: getProductListingUrl()
            },
        }:
        { 
            currency: 'USD',
            locale: 'en-US',
            language: 'en',
            country: 'US',
            view: {
                // url: "https://www.sunbeltrentals.com/equipment-rental/air-compressors-and-air-tools/air-compressors/", // uncomment for local
                url: getProductListingUrl()
            },
            nearbypcs: []
        },
    }
};

export const productListingEngine = buildCommerceEngine(plp_defaultPlpEngineOptions);

export const buildContextForAltInventoryEngine = (contextKeyVals = []) => {
    const similarItemsContext = buildContext(similar_rentals_engine);
    for (let i = 0; i < contextKeyVals.length; i++) {
        similarItemsContext.add(contextKeyVals[i]?.key, contextKeyVals[i]?.val);
    }
};
export const buildContextBasedOnCompanyId = (engineArr = []) => {
    const engines = [rentals_engine, relinfos_engine, productListingEngine, similar_rentals_engine, ...engineArr];
    engines.forEach(engine => {
        const context = buildContext(engine);
        const companyID = localStorage.getItem('companyID') || 1;
        if (companyID && companyID == 2) {
            context.add('website', 'en_CA');
        } else {
            context.add('website', 'en_US');
        }
    });
};

export const updateContextBasedOnCompanyId = (contextKeyVals = [], isAtpDisabled = false) => {
    console.log("plp engine update context", contextKeyVals, isAtpDisabled);
    const authorityType = useCheckAuthorityType();
    const isP2PUser = authorityType === AUTHORITY_TYPE.P2P;
    const isDelivery = !JSON.parse(localStorage.getItem(STORAGE_CONFIG.LOCAL_STORAGE.ISINSTOREPICKUP));
    const disableAtp = isP2PUser && isDelivery || isAtpDisabled;
    const contextData = {};

    for (const element of contextKeyVals) {
        if (disableAtp && element?.key === 'nearbypcs') {
            element.val = [];
        }
        contextData[element?.key] = element?.val;
    }

    sessionStorage.setItem('plpContextData', JSON.stringify(contextData));

    // return (request, clientOrigin, metadata) => {
        // console.log(request.body, clientOrigin)   
        // if (clientOrigin === 'commerceApiFetch' && request.body) {
        //     try {
        //         const body = JSON.parse(request.body);

        //         // Initialize context if not present
        //         body.context = body.context || {};

        //         // Apply updates from `contextKeyVals`
        //         contextKeyVals.forEach(({ key, val }) => {
        //             body.context[key] = disableAtp && key === 'nearbypcs' ? [] : val;
        //         });

        //         request.body = JSON.stringify(body);
        //     } catch (error) {
        //         console.error('Error parsing request body:', error);
        //     }
        // }
        // return request;
    // };
};

